import React from "react"
// import Search from '../services/Search'

class Page extends React.Component {
  constructor(props) {
    super(props)

    this.handleInputClicked = this.handleInputClicked.bind(this)
    this.handleInputChanged = this.handleInputChanged.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.groupDetailHtml = this.groupDetailHtml.bind(this)
  }

  handleInputClicked(){
    let model = this.props.model
    let filters = model.filters
    model.filters.details.on = !model.filters.details.on
    filters.sort_by.on = false
    filters.departments.on = false
    filters.orgs.on = false
    filters.themes.on = false
    if(!filters.details.on){
      model.filters.details.query = ""
    }
    this.props.changeState(model)
  }

  handleInputChanged(event){
    let v = event.currentTarget.value.trim()
    let model = this.props.model
    model.filters.details.query = v
    if(!_.isEmpty(v)){
      model.filters.details.on = true
    }
    this.props.changeState(model)
  }

  handleSelect({event, group, item}){
    let model = this.props.model
    let selected = model.filters.details.selected
    selected[group][item] = !selected[group][item]
    model.filters.pagination.page = 1
    this.props.changeState(model)
    this.props.search({})
  }

  groupDetailHtml({list, group, group_name}){
    const self = this
    const model = self.props.model
    const filters = model.filters

    if(group){
      for(const name in group){
        if(name.toLowerCase().includes(filters.details.query.toLowerCase())){
          const count = group[name]
          let itemHtml = (
            <div key={name} className="ic-item grid-x grid-padding-x"
              onClick={(e)=>{self.handleSelect({event: e, group: group_name, item: name})}}>
              <div className="cell small-2 text-right">
                <i className={`ic-check fal ${filters.details.selected[group_name][name] ? 'fa-check-square' : 'fa-square'}`}></i>
              </div>
              <div className="cell small-8">
                {name}
              </div>
              <div className="cell small-2">
                ({count})
              </div>
            </div>
          )
          list.push(itemHtml)
        }
      }
    }
  }

  render(){
    const self = this
    let list = []
    const model = self.props.model
    const filters = model.filters
    const results = model.results.results

    if(results){
      let groups = results.groups
      if(groups){
        let details = {
          people: groups.people,
          place: groups.place,
          activity: groups.activity
        }

        self.groupDetailHtml({list: list, group: details.people, group_name: 'people'})
        self.groupDetailHtml({list: list, group: details.place, group_name: 'place'})
        self.groupDetailHtml({list: list, group: details.activity, group_name: 'activity'})
      }
    }

    let html = (
      <React.Fragment>
        <div className="filter-title">
          Detail
        </div>
        <div className="search-sel-wrapper">
          <div className="input-list-wrapper" onClick={self.handleInputClicked}>
            <input className="input-list" type="text" value={filters.details.query} onChange={self.handleInputChanged} placeholder="Person, location or activity" />
            <i className="ico-search fal fa-search"></i>
            <i className={`ico-down fal fa-chevron-${filters.details.on ? 'up' : 'down'}`}></i>
          </div>
          <div className={`${filters.details.on ? 'shown' : 'hidden'}`}>
            <div className="indent-list">
              {list}
            </div>
            <div className="list-action text-center hidden">
              Show more details
            </div>
          </div>
        </div>
      </React.Fragment>
    )
    return html
  }
}

export default Page
